<template>
  <!-- banner -->
  <div
    class="relative lg:flex container pt-3 lg:pt-20 pb-5 md:after:border-r-[35px] md:after:border-l-[35px] md:after:border-t-[35px] md:after:border-transparent md:after:border-t-[#fff8ee] after-content[''] md:after:absolute md:after:left-[10%] md:after:top-full md:after:w-0 md:after:h-0"
  >
    <div class="lg:w-[30%]">
      <h1
        class="font-display text-primary text-4xl lg:text-5xl xl:text-[56px] font-bold !leading-[1.2] mb-5"
      >
        {{ $t("home.banner.title") }}
      </h1>
      <p class="font-light text-sm md:text-base text-brand-gray">
        {{ $t("home.banner.text") }}
      </p>
    </div>
    <div
      class="lg:w-[70%] flex flex-col-reverse md:flex-row mt-8 md:mt-0 items-center lg:items-start md:pt-10 lg:pt-0"
    >
      <div class="md:-mr-10 mt-20 md:mt-0 px-7 md:px-0">
        <div class="relative inline-block">
          <img src="/images/happy-box-v2.png" alt="Happy box" />
          <div
            class="bg-[#CCAA80] rounded-full font-display uppercase absolute -top-4 md:-top-10 -right-2 md:left-[2%] w-28 h-28 md:w-[8.5rem] md:h-[8.5rem] rotate-12 flex flex-col justify-center items-center text-sm leading-4 lg:leading-normal"
          >
            <span
              class="text-white font-bold lg:mb-2 text-[10px] lg:text-[13px] text-center [word-spacing:2rem]"
              >{{ $t("home.banner.image.title") }}</span
            >
            <span class="text-[9px] lg:text-[10px] text-center px-4">{{
              $t("home.banner.image.text")
            }}</span>
          </div>
        </div>
      </div>

      <div class="md:w-[60%] flex-shrink-0 z-10 lg:-mt-[19%] md:pl-5">
        <RegistrationAccountInfo />
        <p class="text-brand-gray text-right mt-8 mb-4 hidden md:block">
          {{ $t("home.banner.image.description") }}
        </p>
      </div>
    </div>
    <p class="text-brand-gray text-sm text-right mt-5 md:hidden">
      {{ $t("home.banner.image.description") }}
    </p>
  </div>

  <!-- contents -->
  <HomeHappyBoxContents />

  <div class="bg-[#FFF8EE]">
    <!-- reviews -->
    <HomeReviews />

    <!-- cta -->
    <div
      class="container flex flex-col md:flex-row items-center md:space-x-10 xl:w-1/2 justify-center pt-5 pb-8 md:py-20"
    >
      <p
        class="font-display text-primary text-xl md:text-2xl font-medium mb-6 md:mb-0"
      >
        {{ $t("home.cta.title") }}
      </p>
      <CoreButtonLink
        class="flex-shrink-0 px-16 w-full md:w-fit"
        href="/request-partner"
        >{{ $t("home.cta.button") }}</CoreButtonLink
      >
    </div>
  </div>

  <!-- partners -->
  <HomePartners />
</template>
